import { useTranslation } from 'react-i18next';
import { FormProvider } from 'react-hook-form';
import { PhoneForm } from '@Pages/happyFlowPages/phone/phoneForm/PhoneForm.tsx';
import { StepPageWrapper } from '@Layout/StepPageWrapper.tsx';
import { usePhoneLogic } from '@Pages/happyFlowPages/phone/hooks/usePhoneLogic.ts';
import { RoutesMap } from '@Router/router.types';

interface PhoneProps {
  originRoute?: RoutesMap;
}

export const Phone = ({ originRoute = RoutesMap.PHONE }: PhoneProps) => {
  const { t } = useTranslation();

  const { isPending, setLocalSelectedIsoCode, handleSubmit, formMethods, shouldAllowMultiCountry } =
    usePhoneLogic(originRoute);

  return (
    <FormProvider {...formMethods}>
      <StepPageWrapper
        isLoading={isPending}
        handleSubmit={formMethods.handleSubmit(handleSubmit)}
        heading={t('sectionTitles.personalDetails')}
        formMethods={formMethods}
        content={t('pages.phone.content')}>
        <PhoneForm
          setLocalSelectedIsoCode={setLocalSelectedIsoCode}
          isSelectMenuDisabled={!shouldAllowMultiCountry}
          formMethods={formMethods}
        />
      </StepPageWrapper>
    </FormProvider>
  );
};
